/** Availability data — open-spot counts pulled from Zoho zh_trips (2026-07-20).
 *  TODO: wire to the destinations.hxp.org API so counts stay live, or update here. */

export const lastUpdated = "July 20, 2026";

export type OpenTrip = { trip: string; price: string; dates: string };

/** One row per trip with real dates — the page filters out trips whose start
 *  date has passed, so listings and counts stay honest without manual pruning.
 *  Source: Zoho zh_trips (2026 season), queried 2026-07-21. */
export type TripSlot = {
  trip: string;
  price: string;
  label: string; // e.g. "Trip 9"
  start: string; // ISO date
  end: string; // ISO date
  spots: number;
  intl?: boolean; // international (16–19) vs domestic (14–16)
};

export const boyBuilderTrips: TripSlot[] = [
  { trip: "Almost Heaven", price: "$2,695", label: "Trip 6", start: "2026-07-02", end: "2026-07-11", spots: 1 },
  { trip: "Almost Heaven", price: "$2,695", label: "Trip 7", start: "2026-07-09", end: "2026-07-18", spots: 1 },
  { trip: "Lone Star", price: "$2,695", label: "Trip 3", start: "2026-06-11", end: "2026-06-20", spots: 1 },
  { trip: "Lone Star", price: "$2,695", label: "Trip 5", start: "2026-06-25", end: "2026-07-04", spots: 1 },
  { trip: "Lone Star", price: "$2,695", label: "Trip 6", start: "2026-07-02", end: "2026-07-11", spots: 1 },
  { trip: "Lone Star", price: "$2,695", label: "Trip 10", start: "2026-07-30", end: "2026-08-08", spots: 1 },
  { trip: "Mt. Rushmore, Sioux Nation", price: "$2,695", label: "Trip 5", start: "2026-06-25", end: "2026-07-04", spots: 1 },
  { trip: "Mt. Rushmore, Sioux Nation", price: "$2,695", label: "Trip 9", start: "2026-07-23", end: "2026-08-01", spots: 1 },
];

export const girlBuilderTrips: TripSlot[] = [
  { trip: "Almost Heaven", price: "$2,695", label: "Trip 10", start: "2026-07-30", end: "2026-08-08", spots: 1 },
  { trip: "Brazil Milagre East", price: "$4,295", label: "Trip 4", start: "2026-07-07", end: "2026-07-24", spots: 1, intl: true },
  { trip: "Indonesia Bali Cinta", price: "$4,495", label: "Trip 4", start: "2026-07-13", end: "2026-07-31", spots: 1, intl: true },
  { trip: "Lone Star", price: "$2,695", label: "Trip 3", start: "2026-06-11", end: "2026-06-20", spots: 1 },
  { trip: "Lone Star", price: "$2,695", label: "Trip 5", start: "2026-06-25", end: "2026-07-04", spots: 1 },
  { trip: "Lone Star", price: "$2,695", label: "Trip 6", start: "2026-07-02", end: "2026-07-11", spots: 1 },
  { trip: "Mt. Rushmore, Sioux Nation", price: "$2,695", label: "Trip 2", start: "2026-06-04", end: "2026-06-13", spots: 1 },
  { trip: "Mt. Rushmore, Sioux Nation", price: "$2,695", label: "Trip 5", start: "2026-06-25", end: "2026-07-04", spots: 3 },
  { trip: "Mt. Rushmore, Sioux Nation", price: "$2,695", label: "Trip 9", start: "2026-07-23", end: "2026-08-01", spots: 1 },
  { trip: "OBX", price: "$2,895", label: "Trip 4", start: "2026-06-18", end: "2026-06-27", spots: 1 },
];

export const tripDadTrips: TripSlot[] = [
  { trip: "Dominican Republic Pura Isla South", price: "$3,295", label: "Trip 3", start: "2026-06-24", end: "2026-07-10", spots: 1, intl: true },
  { trip: "Ecuador Galapagos South", price: "$4,495", label: "Trip 5", start: "2026-07-28", end: "2026-08-14", spots: 1, intl: true },
  { trip: "Lone Star", price: "$2,695", label: "Trip 3", start: "2026-06-11", end: "2026-06-20", spots: 1 },
];

export const tripMomTrips: TripSlot[] = [];

export const experienceCards = [
  {
    name: "Refuge",
    caption: "Serve in refugee camps around the world",
    image: "/images/wp/refuge-7d66287d.png",
  },
  {
    name: "Preserve",
    caption: "Serve locals by preserving the Earth",
    image: "/images/wp/screen-shot-2024-11-06-at-2.42.03-pm-fd7c240a.png",
  },
  {
    name: "Build",
    caption: "Serve locals by building sustainable infrastructure",
    image: "/images/wp/build-ff208070.png",
  },
  {
    name: "Teach",
    caption: "Serve locals by sharing your English language skills",
    image: "/images/wp/teach-2a0af487.png",
  },
  {
    name: "Love",
    caption: "Serve & love the deaf/blind community",
    image: "/images/wp/love-d3d6e821.png",
  },
];

export const instagramGallery = [
  { href: "https://www.instagram.com/hxp.cambodiasiemreap/", image: "/images/wp/instagram9-8417e48d.jpg", label: "Cambodia Siem Reap" },
  { href: "https://www.instagram.com/hxp.tongatapu/", image: "/images/wp/screen-shot-2024-11-04-at-1.44.54-pm-447dcf41.png", label: "Tonga Tongatapu" },
  { href: "https://www.instagram.com/hxp.malaysialove/", image: "/images/wp/screen-shot-2024-11-04-at-1.45.17-pm-5875b15d.png", label: "Malaysia Love" },
  { href: "https://www.instagram.com/hxp.ecuadorgalapagos/", image: "/images/wp/screen-shot-2024-11-04-at-1.57.26-pm-f3c160e7.png", label: "Ecuador Galapagos" },
  { href: "https://www.instagram.com/hxp.brazilsantarem/", image: "/images/wp/screen-shot-2024-11-04-at-1.58.14-pm-f6ca8a7d.png", label: "Brazil Santarém" },
  { href: "https://www.instagram.com/hxp.romaniabucharest/", image: "/images/wp/screen-shot-2024-11-04-at-1.57.48-pm-c2c4997d.png", label: "Romania Bucharest" },
  { href: "https://www.instagram.com/hxp.obx/", image: "/images/wp/instagram7-d32dea05.jpg", label: "OBX" },
  { href: "https://www.instagram.com/hxp.teachjapan/reel/C7wCiCXh5k5/", image: "/images/wp/screen-shot-2024-11-04-at-2.00.34-pm-4aaa691c.png", label: "Teach Japan" },
  { href: "https://www.instagram.com/hxp.malawiheartofafrica/", image: "/images/wp/screen-shot-2024-11-04-at-2.01.08-pm-8f9092ca.png", label: "Malawi Heart of Africa" },
];
